








































































































































import { Prop, Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import { Button, Form, FormItem, Option, Tooltip } from 'element-ui';
import RemoteSelect from '@/components/element-ui/RemoteSelect.vue';
import LocationUpsertModal from '@/components/location/LocationUpsertModal.vue';
// types
import {
  TransportationTypeEnum,
  CustomerLocationFields,
  CustomerLocationInput,
  PlaceFields,
  CustomerOrganizationFields
} from '@/types/graphql/schemaTypes';
import locations from '@/mixins/locationOptions.ts';
import places from '@/mixins/placeOptions.ts';
// svg
import containerAllowed from '@/components/svgs/containerAllowed.vue';
import hasCrane from '@/components/svgs/hasCrane.vue';
import hasForklift from '@/components/svgs/hasForklift.vue';
import hasParking from '@/components/svgs/hasParking.vue';
import { CustomerOrganizationState } from '@/types/store';
import { inquiryService } from '../../services/InquiryService';

@Component({
  components: {
    containerAllowed,
    hasParking,
    hasCrane,
    hasForklift,
    LocationUpsertModal,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': RemoteSelect,
    'el-tooltip': Tooltip
  }
})
export default class CustomerLocation extends Mixins(locations, places) {
  @Prop({ }) shipmentId!: string;
  @Prop({ type: String, required: true }) locationType!: 'arrival' | 'departure';
  @Prop({ type: String, required: true }) transportType!: TransportationTypeEnum;
  @Prop({ type: Boolean, default: false }) readOnly!: boolean;
  @Prop({ type: Boolean, default: false }) error!: boolean;
  @Prop({ default: () => ({}) }) customerLocation!: CustomerLocationFields;
  @Prop({ default: () => ({}) }) customerOrganization!: CustomerOrganizationFields;
  @Prop({ default: () => ({}) }) place!: PlaceFields;

  private customerLocationId: string | null = null;
  private selectedCustomerLocation: CustomerLocationFields | null = null;
  private loading = false;
  private placeId: string | null = null;
  private showModal = false;

  public handleCreation(newCustomerLocation: CustomerLocationFields) {
    if (this.selectedCustomerLocation && this.shipmentId) {
      inquiryService.updateInquiry({
        id: this.shipmentId,
        [`${this.locationType}CustomerLocationId`]: this.selectedCustomerLocation.id
      }).then(() => {
        this.$apollo.queries.customerLocationOptions.refetch();
        this.$store.dispatch('Inquiry/setAction', 'update');
      });
      return;
    }

    this.customerLocationOptions.push(this.formatCustomerLocationOptions(newCustomerLocation));
    this.handleSelect(newCustomerLocation.id);
  }

  // handle se selection to trigger creation
  private handleSelect(id: string | null) {
    if (id === 'new') {
      this.showModal = true;
    } else {
      this.customerLocationId = id;
      this.$emit('updateLocation', id);
    }
  }

  private openCreationModal() {
    this.selectedCustomerLocation = null;
    this.showModal = true;
  }

  private openEditModal() {
    this.selectedCustomerLocation = { ...this.customerLocation };
    this.showModal = true;
  }

  private closeModal() {
    this.selectedCustomerLocation = null;
    this.showModal = false;
  }

  // clear port select options when we change type
  @Watch('transportType', { immediate: true })
  private resetOptions(transportType: TransportationTypeEnum) {
    this.transportationType = transportType;
    this.placeOptions = [];
  }

  @Watch('customerLocation', { immediate: true })
  private setCustomerLocation(customerLocation: CustomerLocationFields) {
    this.selectedCustomerLocation = customerLocation;

    if (customerLocation && customerLocation.id) {
      this.customerLocationId = customerLocation.id;
    }
  }

  // if customer organization change we reset selected value
  @Watch('customerOrganization')
  private resetCustomerLocationPlaceId() {
    this.customerLocationId = null;
  }

  @Watch('place', { immediate: true })
  private setPlace(place: PlaceFields) {
    if (place && place.id) {
      this.placeId = place.id;
      this.searchPlace = place.name || '';
      this.placeOptions = [this.formatPlaceOptions(place)];
    }
  }
}
